import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledBoxRow, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Typography, useMediaQuery, useTheme} from "@mui/material";
import {Star, StarBorder} from "@mui/icons-material";
import {PD_LG, PD_SM, PD_XLG, PD_XLG2, PD_XSM} from "@/shared/dimens";
import {TestimonialsSectionData, SiteTemplate} from "../../types";

export function TestimonialsSection(props: { data: TestimonialsSectionData, template: SiteTemplate }): ReactElement {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));

  return <div style={{width: "100%", backgroundColor: "#0D2918"}}>
    <SectionContainer>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      <StyledBoxColumn style={{gap: PD_XLG}}>
        {props.data.testimonials.map((testimonial, i) =>
          <div key={i} style={{
            display: "flex",
            flexWrap: md ? "nowrap" : "wrap",
            gap: PD_XLG2,
            alignItems: "center",
            borderTop: i > 0 ? "1px solid rgba(255,255,255,0.1)" : "none",
            paddingTop: i > 0 ? PD_XLG : 0,
          }}>
            <StyledBoxColumn style={{flex: "1 0 55%", gap: PD_LG}}>
              <Typography style={{
                fontSize: "5.5rem",
                lineHeight: 0.7,
                fontFamily: "Georgia, 'Times New Roman', serif",
                color: theme.palette.secondary.main,
                fontWeight: "bold",
                userSelect: "none",
              }}>
                "
              </Typography>

              {testimonial.rating > 0
                ? <StyledBoxRow style={{gap: PD_XSM}}>
                  {Array.from({length: 5}).map((_, j) =>
                    j < testimonial.rating
                      ? <Star key={j} style={{fontSize: 18, color: "#f5a623"}}/>
                      : <StarBorder key={j} style={{fontSize: 18, color: "#f5a623"}}/>
                  )}
                </StyledBoxRow>
                : null}

              <Typography style={{lineHeight: 1.9, fontSize: "1.05rem", opacity: 0.8, fontStyle: "italic"}}>
                {testimonial.quote}
              </Typography>

              <StyledBoxRow style={{alignItems: "center", gap: PD_SM}}>
                {testimonial.authorImageUrl
                  ? <img
                    src={testimonial.authorImageUrl}
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: "50%",
                      objectFit: "cover",
                      flexShrink: 0,
                      border: `2px solid ${theme.palette.secondary.main}`,
                    }}/>
                  : null}
                <StyledBoxColumn style={{gap: 0}}>
                  <Typography style={{fontWeight: "700"}}>{testimonial.authorName}</Typography>
                  {testimonial.authorTitle
                    ? <Typography variant="body2" style={{opacity: 0.55}}>{testimonial.authorTitle}</Typography>
                    : null}
                </StyledBoxColumn>
              </StyledBoxRow>
            </StyledBoxColumn>

            {md && testimonial.authorImageUrl
              ? <div style={{
                flex: "0 0 35%",
                position: "relative",
                aspectRatio: "3/4",
                borderRadius: 8,
                overflow: "hidden",
              }}>
                <img
                  src={testimonial.authorImageUrl}
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center top",
                  }}/>
                <div style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: 4,
                  backgroundColor: theme.palette.secondary.main,
                }}/>
              </div>
              : null}
          </div>
        )}
      </StyledBoxColumn>
    </SectionContainer>
  </div>;
}
